// extracted by mini-css-extract-plugin
module.exports = {"topHeader":"styles_topHeader__YMDoV","logo":"styles_logo__17aez","item":"styles_item__1mFGY"};